import { render, staticRenderFns } from "./HotelRegistration.vue?vue&type=template&id=19fc25c9&scoped=true&"
import script from "./HotelRegistration.vue?vue&type=script&lang=js&"
export * from "./HotelRegistration.vue?vue&type=script&lang=js&"
import style0 from "./HotelRegistration.vue?vue&type=style&index=0&id=19fc25c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc25c9",
  null
  
)

export default component.exports